import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldDatetime = ({
  id,
  label,
  value,
  handleChange,
  readOnly,
  required,
  styles,
}) => {
  const editing = !readOnly;
  const valueSplit = value.split("T");
  const date = valueSplit[0];
  const time = valueSplit[1].split(".")[0];
  const dateSplit = date.split("-");
  const empty = dateSplit[0] === "" || dateSplit[0] === "0001";
  const visibleValue = empty
    ? ""
    : `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]} ${time}`;

  return (
    <S.Container>
      {label && <S.Title>{label}</S.Title>}
      <S.InputContainer>
        <S.InputWrapper className={editing ? "visible" : "hidden"}>
          <S.Input
            name={id}
            type="date"
            value={empty ? "" : value}
            onChange={(e) => handleChange(id, e.target.value)}
            readOnly={readOnly}
            required={required}
            styles={styles}
          />
        </S.InputWrapper>
        <S.Text className={editing ? "hidden" : "visible"}>
          {visibleValue}
        </S.Text>
      </S.InputContainer>
    </S.Container>
  );
};

FieldDatetime.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  styles: PropTypes.string,
};
